import CrudPage, { fmtMoney } from "../components/CrudPage";
import { StatusBadge } from "../components/Shared";
import { ArrowsLeftRight } from "@phosphor-icons/react";

const CUR_OPTS = [
  { value: "TRY", label: "₺ TRY" }, { value: "USD", label: "$ USD" }, { value: "EUR", label: "€ EUR" }, { value: "GBP", label: "£ GBP" },
];

export default function Transactions() {
  return (
    <CrudPage
      title="Gelir & Gider"
      subtitle="Tüm gelir ve gider işlemleriniz"
      endpoint="transactions"
      exportEntity="transactions"
      emptyIcon={ArrowsLeftRight}
      testidPrefix="txn"
      fields={[
        { name: "type", label: "Tür", type: "select", default: "income", options: [{ value: "income", label: "Gelir" }, { value: "expense", label: "Gider" }] },
        { name: "category", label: "Kategori", default: "Genel" },
        { name: "amount", label: "Tutar", type: "number" },
        { name: "currency", label: "Para Birimi", type: "select", default: "TRY", options: CUR_OPTS },
        { name: "date", label: "Tarih", type: "date" },
        { name: "description", label: "Açıklama", full: true },
      ]}
      columns={[
        { key: "date", label: "Tarih" },
        { key: "type", label: "Tür", render: (i) => (
          <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${i.type === "income" ? "bg-emerald-500/15 text-emerald-400" : "bg-rose-500/15 text-rose-400"}`}>
            {i.type === "income" ? "Gelir" : "Gider"}
          </span>
        ) },
        { key: "category", label: "Kategori" },
        { key: "description", label: "Açıklama" },
        { key: "amount", label: "Tutar", align: "right", render: (i) => (
          <span className={i.type === "income" ? "text-emerald-400" : "text-rose-400"}>
            {i.type === "income" ? "+" : "-"}{fmtMoney(i.amount, i.currency)}
          </span>
        ) },
      ]}
    />
  );
}
